import { useLocation, Navigate } from "react-router-dom";
import HapiIframe from "./HapiIframe";
import NavBar from "../Common/NavBar";
import BancoPortugalInfo from "../Common/BancoPortugalInfo";
import CopyrightInfo from "../Common/CopyrightInfo";
import { MdLock, MdThumbUp } from "react-icons/md";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

export const HapiWrapper = () => {
  const query = useQuery();
  const token = query.get("token");
  const processId = query.get("Guid");

  localStorage.setItem("hapi_guid", processId);
  localStorage.setItem("accessToken", token);

  if (!token || !processId) {
    return <Navigate to='/login' />;
  }

  return (
    <div>
      <NavBar />

      <div className='flex justify-center bg-[#F3F4F6] container-noNav'>
        <div className='w-full sm:p-10 xs:p-6 sm:ml-5 sm:mr-5 max-w-screen-xl justify-center'>
          {/* <BancoPortugalInfo /> */}

          <span className='text-center block w-full md:text-lg sm:text-base text-xs sm:mt-0 mt-4'>


            <div className="flex justify-center items-center rounded-md bg-green-100 py-3 px-6 text-green-800">
              <MdThumbUp className="h-5 w-5 text-green-700 mr-1" />
              <span className="font-bold text-base md:text-base text-xs sm:text-12 xs:text-xs text-center">
                Está a um passo de transformar a sua proposta em aprovação — em menos de 24h.
              </span>
            </div>

            <br />

            <span className='text-base md:text-base text-xs sm:text-12 xs:text-xs block sm:mt-6 xs:mt-0 mt-0'>
            Confirme os seus dados de forma <b>100% segura</b> através do <b>Portal das Finanças</b> e da <b>Segurança Social</b>. O acesso é temporário, encriptado e usado apenas para agilizar a aprovação do seu crédito.
            </span>
          </span>

          <div className='w-full max-w-screen-xl mx-auto mt-10 mb-2 md:mt-10 md:mb-2 xs:mt-4 xs:mb-2'>
            <div>
              <HapiIframe token={token} processId={processId} />
            </div>
          </div>

          <span className='text-center block w-full md:text-lg sm:text-base text-xs sm:mt-0 mt-4'>
            <span className='font-bold block w-full text-base md:text-base text-xs sm:text-12 xs:text-xs'>
              🔒 Mais de 80% dos nossos clientes usam este método rápido e seguro.
            </span>
            <br />
          </span>

          

          <CopyrightInfo className='px-4' />
        </div>
      </div>
    </div>
  );
};
